/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environmentStaging = {
  env: 'staging',
  backend: 'https://app-staging.storydoc.com/api',
  stories: 'https://www-staging.storydoc.com',
  assets: 'https://assets-staging.storydoc.com',
  oktaAppId: '0oa4hp85crSg96e4I5d6',
  assetsLink: 'https://editor-bundle-staging.storydoc.com',
  frontPublicUrl: 'https://www-staging.storydoc.com/assets/editor'
};
